import React from 'react';
import { FDBodyText, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';

const GoalSummaryItemLineItem = ({
  value,
  label,
}) => {
  return (
    <FDStack direction={'row'} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
      <FDBodyText value={label} />
      <FDBodyText value={value} />
    </FDStack>
  );
};

GoalSummaryItemLineItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export { GoalSummaryItemLineItem };
